import { useRef, useState } from "react";
import { Card } from "react-bootstrap";
import AccessDenied from "../../ui/AccessDenied";

// Components
import SplosnoDetails from "./SplosnoDetails";
import SplosnoForm from "./SplosnoForm";
import TabCardHeader from "../../ui/TabCardHeader";
import UnsavedChangesModal from "../../ui/UnsavedChangesModal";
import RoleGuard from "../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../auth/roles";
import { useProjectDetailsContext } from "../../../context/ProjectDetailsContext";

const Splosno = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const isDirtyRef = useRef(false);
  const { project } = useProjectDetailsContext();

  // Toggle edit mode, but if there are unsaved changes, show the modal instead
  const handleEditToggle = () => {
    if (isEditing && isDirtyRef.current) {
      setShowUnsavedModal(true);
      return;
    }
    setIsEditing((prev) => !prev);
  };

  // If user confirms they want to discard changes, close modal and exit edit mode
  const handleDiscardChanges = () => {
    setShowUnsavedModal(false);
    setIsEditing(false);
  };

  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <Card className="mb-4">
        {/* Header with title and edit button is checked with RoleGuard */}
        <RoleGuard
          moduleKey={MODULES.PROJEKTI}
          roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
          vodilnaClanicaProjektaID={project?.clanicaID}
          fallback={<TabCardHeader title="Splošno" />}
        >
          <TabCardHeader
            title="Splošno"
            showEditButton={true}
            editing={isEditing}
            onEditToggle={handleEditToggle}
          />
        </RoleGuard>
        <div className="px-4 pt-4 pb-2">
          {isEditing ? (
            <SplosnoForm
              setIsEditing={setIsEditing}
              onDirtyChange={(dirty) => (isDirtyRef.current = dirty)}
            />
          ) : (
            <SplosnoDetails />
          )}
        </div>
        <UnsavedChangesModal
          show={showUnsavedModal}
          onCancel={() => setShowUnsavedModal(false)}
          onDiscard={handleDiscardChanges}
        />
      </Card>
    </RoleGuard>
  );
};

export default Splosno;
